if (!customElements.get('jersey-customizer')) {
  customElements.define('jersey-customizer', class JerseyCustomizer extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready === 'true') return;
      this.dataset.ready = 'true';

      this.form = this.closest('form');
      this.nameInput = this.querySelector('[name="properties[Custom Name]"]');
      this.numberInput = this.querySelector('[name="properties[Custom Number]"]');
      this.confirmInput = this.querySelector('[name="properties[Details confirmed]"]');
      this.preview = this.querySelector('[data-custom-preview]');

      if (!this.form || !this.nameInput || !this.numberInput || !this.confirmInput) return;

      this.cacheKey = 'mofabia-jersey-' + (this.dataset.productId || 'custom');
      window.mofabiaJerseyDrafts = window.mofabiaJerseyDrafts || {};
      const saved = window.mofabiaJerseyDrafts[this.cacheKey];
      if (saved) {
        this.nameInput.value = saved.name || '';
        this.numberInput.value = saved.number || '';
        this.confirmInput.checked = Boolean(saved.confirmed);
      }

      this.nameInput.addEventListener('input', () => {
        this.nameInput.value = this.nameInput.value.replace(/[^A-Za-zÀ-ÖØ-öø-ÿ' -]/g, '');
        this.updatePreview();
        this.saveDraft();
        this.clearError('name', this.nameInput);
      });

      this.numberInput.addEventListener('input', () => {
        this.numberInput.value = this.numberInput.value.replace(/\D/g, '').slice(0, 2);
        this.updatePreview();
        this.saveDraft();
        this.clearError('number', this.numberInput);
      });

      this.confirmInput.addEventListener('change', () => {
        this.saveDraft();
        this.clearError('confirm', this.confirmInput);
      });

      this.form.addEventListener('submit', (event) => {
        if (!this.validate()) {
          event.preventDefault();
          event.stopImmediatePropagation();
        }
      }, true);

      this.updatePreview();
    }

    saveDraft() {
      window.mofabiaJerseyDrafts[this.cacheKey] = {
        name: this.nameInput.value,
        number: this.numberInput.value,
        confirmed: this.confirmInput.checked
      };
    }

    updatePreview() {
      const name = this.nameInput.value.trim().toLocaleUpperCase() || 'YOUR NAME';
      const number = this.numberInput.value.trim() || '00';
      this.preview.textContent = name + ' · ' + number;
    }

    clearError(key, input) {
      input.removeAttribute('aria-invalid');
      const error = this.querySelector('[data-error-for="' + key + '"]');
      if (error) error.textContent = '';
    }

    setError(key, input, message) {
      input.setAttribute('aria-invalid', 'true');
      const error = this.querySelector('[data-error-for="' + key + '"]');
      if (error) error.textContent = message;
    }

    validate() {
      let valid = true;
      const name = this.nameInput.value.trim();
      const number = this.numberInput.value.trim();

      this.clearError('name', this.nameInput);
      this.clearError('number', this.numberInput);
      this.clearError('confirm', this.confirmInput);

      if (!name) {
        this.setError('name', this.nameInput, 'Enter the name you want printed.');
        valid = false;
      } else if (name.length > 12) {
        this.setError('name', this.nameInput, 'Use no more than 12 characters.');
        valid = false;
      }

      if (!/^\d{1,2}$/.test(number)) {
        this.setError('number', this.numberInput, 'Enter a number from 0 to 99.');
        valid = false;
      }

      if (!this.confirmInput.checked) {
        this.setError('confirm', this.confirmInput, 'Confirm the details before adding this item.');
        valid = false;
      }

      if (!valid) {
        const firstInvalid = this.querySelector('[aria-invalid="true"]');
        if (firstInvalid) firstInvalid.focus();
      }

      return valid;
    }
  });
}
